/**
 * Initialise Tako Tag
 */

/* -----------------------------------------------------------------------------
 * Tako Tag
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'Tag';

export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    // ToDo: Remove tako-tag--dismissible with the next breaking change
    const allDismissibleTakoTags = scope.querySelectorAll(
        '.tako-tag[data-dismissible], .tako-tag--dismissible',
    );

    /**
     * tako-tag--dismissible class is @deprecated
     */
    const dismissableTagsWithLegacyClass = scope.querySelectorAll(
        '.tako-tag--dismissible',
    );

    if (dismissableTagsWithLegacyClass.length) {
        logger.warn(
            'The `tako-tag--dismissible` class is deprecated. Please use the `data-dismissible` attribute instead.',
            defaultLoggerArgs,
        );
    }

    allDismissibleTakoTags.forEach((takoTag) => {
        try {
            const dismissButton = document.createElement('button');
            dismissButton.classList.add(
                'tako-button',
                'tako-button--ghost',
                'tako-button--icon',
                'tako-button--inherit',
                'tako-button--no-padding',
            );

            dismissButton.setAttribute('data-tag-dismiss', 'true');
            dismissButton.setAttribute('aria-label', 'Close');
            dismissButton.innerHTML = `<span class="tako-icon tako-icon--sm"><i class="far fa-xmark" aria-hidden="true"></i></span>`;

            takoTag.appendChild(dismissButton);

            const dismissAlert = () => {
                takoTag.style.display = 'none';
            };

            dismissButton.addEventListener('click', dismissAlert);
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: takoTag,
            });
        }
    });
};
